import React from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import IprojectData from "../../interfaces/projectData.interface";
import { fetchProjects } from "../../features/Project/ProjectSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import OpenButton from "../popup_components/OpenButton";
import NewCruisePopup from "../Forms/NewProject";
import { usePopup } from '../../context/PopupContext';
import ModifyProjectPopup from '../Forms/ModifyProject';
import Button from '../Button';
import { useNotification } from '../../context/NotificationContext';
import { setCurrentProject } from 'features/Aggregate/AggregateSlice';

export default function Project() {
    const dispatch = useAppDispatch();
    const projects = useAppSelector(state => state.Projects.projects);
    const current_project = useAppSelector(state => state.Projects.current_project);
    const [output, setOuput] = useState([] as IprojectData[]);
    const [active, setActive] = useState<IprojectData | undefined>();
    const { setPopupContent, openPopup } = usePopup();
    const { notify } = useNotification();
    
    useEffect(() => {
        dispatch(fetchProjects());
    }, []);

    useEffect(() => {
        setOuput(projects);
    }, [projects]);

    const stopCruise = (event: any) => {
        axios.post(process.env.REACT_APP_API_URI + `/projects/actions/stopProject`, {});
        notify("Project '"+current_project?.name+"' stopped", { backgroundColor: "#ff0000", autoCloseMs: 3000 });
        
    };

    const selectProject = (event: any) => {
        const project = event.target.value;
        if (project > 0) {
            axios.post(process.env.REACT_APP_API_URI + `/projects/actions/startProject`, { project_id: event.target.value });
            //notify("Project '"+current_project?.name+"' started", { backgroundColor: "#00FF00", autoCloseMs: 3000 });
        } else if (project == -1) {
            // Open the popup for the new cruise
            setPopupContent(<NewCruisePopup />);
            openPopup();
            // Reset the select option back to value 0
            event.target.value = '0';
        }
    };

    return (
        <>
            {current_project == null ? (
                <select className="border rounded dark:bg-ndgray dark:border-black" onChange={(event) => selectProject(event)}>
                    <option value='0'></option>
                    {output.map((project: IprojectData) => (
                        <option key={project.id} value={project.id}>
                            {project.mfp_id} - {project.name} - {dayjs(project.start_date).format("YYYY-MM-DD")}
                        </option>
                    ))}
                    <option value='-1'>New cruise...</option>
                </select>
            ) : (
                <>
                    <table>
                        <tbody>
                            <tr className='th-readability'>
                                <td className='font-bold'>Mission name:</td>
                                <td>
                                    {current_project.name}
                                    {current_project.original_name && current_project.original_name !== current_project.name && (
                                    <> ({current_project.original_name})</>
                                    )}
                                </td>
                            </tr>
                            <tr className='th-readability'>
                                <td className='font-bold'>Chief Scientist:</td>
                                <td>
                                    {current_project.chief_scientist}
                                    {current_project.original_chief_scientist && current_project.original_chief_scientist !== current_project.chief_scientist && (
                                    <> ({current_project.original_chief_scientist})</>
                                    )}
                                </td>
                            </tr>
                            
                            <tr className='th-readability'>
                                <td className='font-bold'>Port of Departure:</td>
                                <td>
                                    {current_project.departure_port}
                                    {current_project.original_departure_port && current_project.original_departure_port !== current_project.departure_port && (
                                    <> ({current_project.original_departure_port})</>
                                    )}
                                </td>
                            </tr>
                            <tr className='th-readability'>
                                <td className='font-bold'>Port of Arrival</td>
                                <td>
                                    {current_project.arrival_port}
                                    {current_project.original_arrival_port && current_project.original_arrival_port !== current_project.arrival_port && (
                                    <> ({current_project.original_arrival_port})</>
                                    )}
                                </td>
                            </tr>
                            <tr className='th-readability'>
                            <td className='font-bold'>Cruise period:</td>
                            <td>
                                {dayjs(current_project.start_date).format("YYYY-MM-DD")} - {dayjs(current_project.end_date).format("YYYY-MM-DD")}
                                {(
                                    (current_project.original_start_date && current_project.original_start_date !== current_project.start_date) ||
                                    (current_project.original_end_date && current_project.original_end_date !== current_project.end_date)
                                ) && (
                                    <> (
                                        {dayjs(current_project.original_start_date).format("YYYY-MM-DD")} - {dayjs(current_project.original_end_date).format("YYYY-MM-DD")}
                                    )</>
                                )}
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    {/* <button className='button_secondary w-1/4 mr-2' type='submit'>Modify cruise</button> TODO V1.1 */}
                    <div className="flex justify-between items-center gap-1">
                        <Button label='Stop cruise' width='full' onClick={(event) => { stopCruise(event) }} />
                        <OpenButton text='Modify Cruise' styleClasses='rounded w-full' newContent={<ModifyProjectPopup />} />
                    </div>
                </>
            )}
        </>
    );
};
